import('./deps').then(
  ({
    ReactDOM,
    React,
    InsightsThemeProvider,
    KeybindingManager,
    Provider,
    Contents,
    CssBaseline,
    i18ninit,
    SnackbarProvider,
    store,
  }) => {
    i18ninit([]);

    // const videoId = window.location.pathname.match(/^\/v\/\w+$/)?.[0];

    ReactDOM.render(
      <Provider store={store}>
        <InsightsThemeProvider>
          <CssBaseline />
          <KeybindingManager />
          <SnackbarProvider maxSnack={4} autoHideDuration={2000}>
            <Contents {...(globalThis as any).ReplayContext}/>
          </SnackbarProvider>
        </InsightsThemeProvider>
      </Provider>,
      document.getElementById('video-react-root') as HTMLElement,
    );
  },
);
